import React from "react";
import Card from "../../components/page/Card";
import JornadasDataTable from "./JornadaTrabalho/JornadasDataTable";
import JornadaModal from "./JornadaTrabalho/JornadaModal";
import useDadosContratuais from "../../hooks/colaboradores/useDadosContratuais";

function JornadaTrabalho() {
  const [novo] = React.useState(false);

  const {
    jornadas,
    jornadaModal,
    setJornadaModal,
    jornadaValues,
    setJornadaValues,
    togNovaJornadaModal,
    salvaJornada,
    togEditarJornadaModal,
    excluirJornada,
  } = useDadosContratuais();

  return (
    <>
      <Card>
        <JornadasDataTable
          linhas={jornadas}
          togNovaJornadaModal={togNovaJornadaModal}
          togEditarJornadaModal={togEditarJornadaModal}
          apagaJornada={excluirJornada}
        />
      </Card>
      <JornadaModal
        valuesHook={{ values: jornadaValues, setValues: setJornadaValues }}
        isOpen={jornadaModal}
        setIsOpen={setJornadaModal}
        novo={novo}
        salvaJornada={salvaJornada}
      />
    </>
  );
}

export default JornadaTrabalho;
